module.exports = __webpack_public_path__ + "static/media/shadow.69e30eb6.jpg";